/* eslint-disable no-param-reassign */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import React from 'react';

import classNames from 'classnames';

import classes from './styles.module.scss';
import videoTimeToHMS from '../../../../../helpers/videoTimeToHMS';

export default function Segment({
  segment,
  currentSegmentId,
  videoRef,
  setIsPlaying,
  miniVideoRef,
}) {
  return (
    <li
      className={classNames(classes.Segment, {
        [classes.active]: currentSegmentId === segment.id,
      })}
      onClick={() => {
        if (videoRef.current) {
          videoRef.current.currentTime = segment.start_time;
          if (miniVideoRef?.current) {
            miniVideoRef.current.currentTime = segment.start_time;
          }
          videoRef.current.play();
          miniVideoRef?.current?.play();
          setIsPlaying(true);
        }
      }}
    >
      <div className={classes.timestamp}>
        {videoTimeToHMS(segment.start_time)}
      </div>
      <p>{segment.transcript}</p>
    </li>
  );
}
